import { render, staticRenderFns } from "./LicensesList.vue?vue&type=template&id=002f0d40&"
import script from "./LicensesList.vue?vue&type=script&lang=js&"
export * from "./LicensesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports